import { combineReducers } from 'redux'
import { cartReducer } from './cart/cart.reducer'
import { categoriesReducer } from './categories/categories.reducer'
import { userReducer } from './user/user.reducer'

//key: reducer slice, value: actual reducer function

export const rootReducer = combineReducers({
    user: userReducer,
    categories: categoriesReducer,
    cart: cartReducer
})
